document.querySelectorAll('[data-media-text-progression]').forEach((section) => {
  const points = Array.from(section.querySelectorAll('[data-media-text-progression-point]'));
  const mediaItems = section.querySelectorAll('[data-media-text-progression-media]');
  const fill = section.querySelector('[data-media-text-progression-fill]');
  const line = section.querySelector('[data-media-text-progression-line]');
  const track = section.querySelector('.media-text-progression__track');
  if (points.length < 2 || !fill || !line || !track) return;

  let activeIndex = -1;
  let lineTop = 0; // the dot-center Y of the first point, relative to the track

  // Heading size/line-height are merchant-configurable, so the dot's exact
  // pixel position can't be assumed - it's measured from the real element.
  const dotCenterY = (index) => {
    const dot = points[index].querySelector('[data-media-text-progression-dot]');
    if (!dot) return 0;
    const trackRect = track.getBoundingClientRect();
    const dotRect = dot.getBoundingClientRect();
    return dotRect.top + dotRect.height / 2 - trackRect.top;
  };

  const measureLine = () => {
    lineTop = dotCenterY(0);
    const lineBottom = dotCenterY(points.length - 1);
    line.style.top = `${lineTop}px`;
    line.style.height = `${Math.max(lineBottom - lineTop, 0)}px`;
    fill.style.top = `${lineTop}px`;
    if (activeIndex >= 0) {
      fill.style.height = `${Math.max(dotCenterY(activeIndex) - lineTop, 0)}px`;
    }
  };

  const setActive = (index) => {
    if (index === activeIndex) return;
    activeIndex = index;

    points.forEach((point) => {
      const pointIndex = Number(point.dataset.index);
      point.classList.toggle('is-active', pointIndex === index);
      // Once scrolled past a dot, keep it (and the track behind it) filled
      // with the active color instead of reverting to gray.
      point.classList.toggle('is-passed', pointIndex <= index);
    });
    mediaItems.forEach((item) => {
      item.classList.toggle('is-active', Number(item.dataset.index) === index);
    });

    fill.style.height = `${Math.max(dotCenterY(index) - lineTop, 0)}px`;
  };

  // Picks whichever point sits closest to the viewport centerline, rather than
  // relying on IntersectionObserver's narrow trigger band (which fast scrolling
  // can jump straight past, skipping points or firing them out of order).
  const update = () => {
    const viewportCenter = window.innerHeight / 2;
    let closestIndex = 0;
    let closestDistance = Infinity;

    points.forEach((point, i) => {
      const rect = point.getBoundingClientRect();
      const center = rect.top + rect.height / 2;
      const distance = Math.abs(center - viewportCenter);
      if (distance < closestDistance) {
        closestDistance = distance;
        closestIndex = i;
      }
    });

    setActive(closestIndex);
  };

  let ticking = false;
  const requestUpdate = () => {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(() => {
      update();
      ticking = false;
    });
  };

  const requestMeasure = () => {
    measureLine();
    requestUpdate();
  };

  window.addEventListener('scroll', requestUpdate, { passive: true });
  window.addEventListener('resize', requestMeasure);
  window.addEventListener('load', requestMeasure);
  if (document.fonts && document.fonts.ready) {
    // Web fonts loading after the initial measure can change heading
    // line-height, shifting the dots; re-measure once they're settled.
    document.fonts.ready.then(requestMeasure);
  }

  requestMeasure();
});
